import { GraphQL } from "@rpi/openapi-api";

export const fmtDashboardName = (user?: Pick<GraphQL.DashboardUserResponse, "firstName" | "username">) => {
  if (!user) return "";
  if (user.firstName) return user.firstName;
  return user.username ?? "";
};

export const fmtFullName = (user?: Pick<GraphQL.DashboardUserResponse, "firstName" | "lastName">) => {
  if (!user) return "";
  return `${user.firstName} ${user.lastName}`;
};

export const fmtEmail = (user?: Pick<GraphQL.DashboardUserResponse, "email">) => {
  if (!user) return "";
  return user.email;
};
